import React,{Component} from 'react'
import { Link } from "react-router-dom";
import qatarsvg from '../img/qatar.svg'
import logo from '../img/logo.svg'
import ussvg from '../img/us.svg'
import { Navbar,Nav,DropdownButton, Dropdown , NavItem,NavLink, ButtonGroup ,Button} from 'react-bootstrap'
export default class Header extends Component {

  constructor(props) {
    super(props)
    this.state = { }
  }

 

  render(){
 
    return(
        <div>
          
          
          <Navbar bg="light" collapseOnSelect expand="lg" >
  <Navbar.Brand > <Link to="/" >
        <img className="logo horizontal-logo" src={logo} alt="logo"  style={{width:"150px", marginRight:"4rem", marginLeft:"2rem"}} />
      </Link></Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
    <Nav className="mr-auto">

      <Nav.Link >
        <Button variant="Info" style={{
          padding: "0px",
          marginTop: "0.4rem",
          marginRight: "1rem" }}>
            <Link to="/"  style={{color: "#424242"}}>
              <b> Home </b>
            </Link>
        </Button>
      </Nav.Link>

      <Nav.Link > 
        <Dropdown as={ButtonGroup} >
          <Button variant="Info" style={{
    padding: "0px"}}>
          <Nav.Link aria-controls="responsive-navbar-nav">
            <Link to="/aboutus" style={{color: "#424242"}}>
             <b>About </b>
          </Link>
          </Nav.Link>
          </Button>

          <Dropdown.Toggle split variant="Info" id="dropdown-split-basic" />

          <Dropdown.Menu>
            <Dropdown.Item><Link to="/presidentsbio" style={{color: "black"}}>President’s Bio</Link></Dropdown.Item>
            <Dropdown.Item > <Link to="/coreteam" style={{color: "black"}} >Core Team</Link></Dropdown.Item>
            <Dropdown.Item > <Link to="/organization_structure" style={{color: "black"}}> Organization Structure </Link></Dropdown.Item>
          </Dropdown.Menu>
      </Dropdown>
      </Nav.Link>

      <Nav.Link > 
      <Dropdown as={ButtonGroup} id="collasible-nav-dropdown">
          <Button variant="Info" style={{
    padding: "0px"}}>
          <Nav.Link >
            <Link to="/liveclassroomtechnology" style={{color: "#424242"}}>
            <b>Technology </b>
            
          </Link>
          </Nav.Link>
          </Button>

          <Dropdown.Toggle split variant="Info" id="dropdown-split-basic" />

          <Dropdown.Menu>
            <Dropdown.Item  id="collasible-nav-dropdown"><Link to="/liveclassroomtechnology" style={{color: "black"}}>Live Classroom Technology</Link></Dropdown.Item>
            <Dropdown.Item><Link to="/location" style={{color: "black"}}>Our Location</Link></Dropdown.Item>
            <Dropdown.Item><Link to="/technology_partner" style={{color: "black"}}>Technology Partner</Link></Dropdown.Item>
          </Dropdown.Menu>
      </Dropdown>
      </Nav.Link>

      <Nav.Link>
      <Dropdown as={ButtonGroup}>
          <Button variant="Info" style={{
    padding: "0px"}}>
          <Nav.Link >
            <Link to="/academics" style={{color: "#424242"}}>
           <b>Academics </b>
          </Link>
          </Nav.Link>
          </Button>

          <Dropdown.Toggle split variant="Info" id="dropdown-split-basic" />

          <Dropdown.Menu>
            <Dropdown.Item><Link to="/academics" style={{color: "black"}}>Degrees & Programs</Link></Dropdown.Item>
            <Dropdown.Item><Link to="/admissions" style={{color: "black"}}>Admissions</Link></Dropdown.Item>
            <Dropdown.Item><Link to="/transfers" style={{color: "black"}}> Transfers</Link></Dropdown.Item>
            <Dropdown.Item><Link to="/students_services" style={{color: "black"}}> Student Services</Link></Dropdown.Item>
          </Dropdown.Menu>
      </Dropdown>
      </Nav.Link>

      <Nav.Link>
      <Dropdown as={ButtonGroup}>
          <Button variant="Info" style={{
    padding: "0px"}}>
          <Nav.Link >
            <Link to="/aspirecampus" style={{color: "#424242"}}>
            <b>Aspire Campus</b>
          </Link>
          </Nav.Link>
          </Button>

          <Dropdown.Toggle split variant="Info" id="dropdown-split-basic" className={{padding: "0px"}} />

          <Dropdown.Menu>
            <Dropdown.Item><Link to="/aspirezone" style={{color: "black"}}>Aspire Zone</Link></Dropdown.Item>
            <Dropdown.Item><Link to="/aspireacademy" style={{color: "black"}}>Aspire Academy</Link></Dropdown.Item>
            
          </Dropdown.Menu>
      </Dropdown>
      </Nav.Link>

      <Nav.Link>
      <Dropdown as={ButtonGroup}>
          <Button variant="Info" style={{
    padding: "0px"}}>
          <Nav.Link >
            <Link to="/partner_universities" style={{color: "#424242"}}>
           <b> Partner Universities</b>
          </Link>
          </Nav.Link>
          </Button>

          <Dropdown.Toggle split variant="Info" id="dropdown-split-basic" />

          <Dropdown.Menu>
            <Dropdown.Item><Link to="/partner_university_suny" style={{color: "black"}}>SUNY Adirondack</Link></Dropdown.Item>
            <Dropdown.Item><Link to="/partner_university_south_carolina" style={{color: "black"}}>University of South Carolina</Link></Dropdown.Item>
            <Dropdown.Item><Link to="/partner_university_arkansas" style={{color: "black"}}> Arkansas State University</Link> </Dropdown.Item>
          </Dropdown.Menu>
      </Dropdown>
      </Nav.Link>

      <Nav.Link>
      <Button variant="Info" style={{
    padding: "0px",
    marginTop: "0.3rem"}}>
      <Link to="/contactus" style={{color: "#424242"}}>
        <b>Contact Us</b>
        </Link>
        </Button>
      </Nav.Link>


      <li class="nav-item dropdown">
        <Button variant="Info">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown3" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <img src={ussvg} />
          </a>
          </Button>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown3">
            <a class="dropdown-item" href=""><img src={qatarsvg}/></a>
          </div>
          
        </li>
     
    </Nav>
   
  </Navbar.Collapse>
</Navbar>
        </div>
    )
  }
}

